import { useStaticQuery, graphql } from 'gatsby';
import { get } from 'lodash-es';

const Q = graphql`
  {
    orderManager: markdownRemark(frontmatter: { casesManager: { eq: true } }) {
      frontmatter {
        casesOrder {
          casename
        }
      }
    }
    cases: allMarkdownRemark(
      filter: {
        frontmatter: {
          templateKey: { eq: "case-study" }
          published: { ne: false }
        }
      }
    ) {
      edges {
        node {
          ...caseStudyDataCard
        }
      }
    }
  }
`;

const CasesDataProvider = () => {
  const data = useStaticQuery(Q);

  const cases = get(data, 'cases.edges').map(({ node }) => {
    return node;
  });

  const sortedCases = cases.sort((a, b) => {
    const date1 = new Date(a.frontmatter.date);
    const date2 = new Date(b.frontmatter.date);
    return date2 - date1;
  });

  return sortedCases;
};

export default CasesDataProvider;
